module.exports = __webpack_public_path__ + "static/media/fal_fal_bar_fen_hoa.18a000fd.png";